import React from 'react';
import { RichText, Elements } from 'prismic-reactjs';

import * as styles from './styles.module.scss';

type Props = {
    text: any;
    text_color: string;
    isAmp?: boolean;
};

const ContentSlice: React.FunctionComponent<Props> = ({ text, text_color, isAmp = false }) => {
    const customLink = (type, element, content, children, index) => <a href={element.data.url}>{content}</a>;

    const propsWithUniqueKey = (props: any, key: string) => {
        return Object.assign(props || {}, { key });
    };

    const htmlSerializer = (type, element, content, children, key) => {
        //I don't know the reason this was setup like that :: Instagram not showing up on AMP
        // if (type === 'embed' && element?.oembed?.type !== 'video' && isAmp) return <div />;

        switch (type) {
            // if image then create create image wrapper div with img
            // if alt then add alt as image caption below
            case Elements.image:
                const imgOpts = () => {
                    if (isAmp) {
                        return {
                            layout: 'responsive',
                        };
                    }
                    return {
                        loading: 'lazy',
                    };
                };

                const aspectRatio = () => {
                    if (element.dimensions.height < element.dimensions.width * 0.4) return `3%3A1`;
                    return `3%3A2`;
                };

                const img = React.createElement('img', {
                    src: element.url.includes('images.prismic.io')
                        ? `${element?.url}&fit=max&q=70&w=300&ar=${aspectRatio()}`
                        : element?.url,
                    alt: element.alt || '',
                    height: element.dimensions.height < element.dimensions.width * 0.4 ? 100 : 200,
                    width: 300,
                    ...imgOpts(),
                });
                return React.createElement(
                    'div',
                    propsWithUniqueKey({ className: 'post_img_wrapper' }, key),
                    // If image element has hyperlink than wrap image with a component
                    element?.linkTo?.url
                        ? React.createElement(
                              'a',
                              {
                                  href: element?.linkTo?.url,
                                  // Link type for hyperlink for Web than add opts
                                  ...(element?.linkTo?.link_type === 'Web'
                                      ? {
                                            rel: 'noreferrer',
                                            target: '_blank',
                                        }
                                      : null),
                              },
                              img
                          )
                        : img,
                    // If image has alt then add span (foot note) under image.
                    element?.alt
                        ? React.createElement(
                              'span',
                              propsWithUniqueKey({ style: { color: '#2f4758' } }, key),
                              element.alt
                          )
                        : null
                );

            // return all other types as default html
            default:
                return null;
        }
    };

    return (
        <div className={styles['post_slice']} style={{ color: text_color }}>
            <RichText render={text.raw} serializeHyperlink={customLink} htmlSerializer={htmlSerializer} />
        </div>
    );
};

export default ContentSlice;
